import {jwtDecode} from "jwt-decode";
import React, {FC} from "react";
import {Navigate} from "react-router-dom";
import App from "./App";
import MyAccount from "./components/MyAccount/MyAccount";
import MyAccountInfo from "./components/MyAccount/MyAccountInfo";
import OrdersValidation from "./components/Validation/OrdersValidation";
import ClientManagement from "./components/MyAccount/ClientManagement/ClientManagement";
import ClientManagementOrganization from "./components/MyAccount/ClientManagement/ClientManagementOrganization";
import CincuPricesPage from "./components/MyAccount/CincuPrices/CincuPricesPage";

export interface AuchanJwtPayload {
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;
    "permission": any;
}

type GuardedRouteAuthProps = {
    component: React.ComponentType;
    reverse?: boolean;
}

function isAuthenticated() {

    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const refreshTokenExpiryTime = localStorage.getItem('refreshTokenExpiryTime');

    if (token === null || refreshToken === null || refreshTokenExpiryTime === null || new Date(refreshTokenExpiryTime!.toLocaleString()) < new Date()) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('refreshTokenExpiryTime');
        return false;
    }
    return true;
}

const GuardedRouteAuth: FC<GuardedRouteAuthProps> = ({component: Component, reverse = false}) => {

    const authenticated = isAuthenticated();

    if (!reverse && !authenticated) {
        return <Navigate to="/login" replace/>
    }
    if (reverse && authenticated) {
        return <Navigate to="/" replace/>
    }

    if (authenticated) {
        const decodedToken = jwtDecode<AuchanJwtPayload>(localStorage.getItem("token")!);
        const userRole = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"].toUpperCase();
        const permissions = decodedToken["permission"]

        if ((Component === App || Component === MyAccount || Component === MyAccountInfo)) {

            if (userRole === "AUCHANMBAEMPLOYEE") {
                return <Navigate to="/my-account/delivery-note" replace/>
            }
            if (userRole !== "BASIC") {
                return <Navigate to="/my-account/preorders" replace/>
            }
        }

        if (Component === OrdersValidation) {
            if (userRole === "AUCHANMBAEMPLOYEE") {
                return <Navigate to="/my-account/delivery-note" replace/>
            }
            if ((userRole === "BASIC")) {
                return <Navigate to="/" replace/>
            }
        }

        if (Component === CincuPricesPage) {
            if (userRole !== "ADMIN" && userRole !== "SUPERADMIN" && userRole !== "B2BSUPPORT") {
                if (userRole === "AUCHANMBAEMPLOYEE") {
                    return <Navigate to="/my-account/delivery-note" replace/>
                }
                if (userRole === "BASIC") {
                    return <Navigate to="/my-account" replace/>
                }
                return <Navigate to="/my-account/preorders" replace/>
            }
        }

        if (Component === ClientManagement || Component === ClientManagementOrganization) {
            if (userRole === "AUCHANMBAEMPLOYEE") {
                return <Navigate to="/my-account/delivery-note" replace/>
            }
            if ((userRole === "BASIC")) {
                return <Navigate to="/my-account" replace/>
            }

            if (!(permissions.includes("Permissions.OrganizationManagment.View") || permissions.includes("Permissions.OrganizationManagment.Edit"))) {
                return <Navigate to="/my-account/preorders" replace/>
            }
        }

    }

    return <Component/>;
};

export {GuardedRouteAuth};

